import { render, staticRenderFns } from "./GeneClassSymbolRegistrationForm.vue?vue&type=template&id=45ae2b68&scoped=true"
import script from "./GeneClassSymbolRegistrationForm.vue?vue&type=script&lang=js"
export * from "./GeneClassSymbolRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./GeneClassSymbolRegistrationForm.vue?vue&type=style&index=0&id=45ae2b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae2b68",
  null
  
)

export default component.exports